import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import { withStyles } from "@material-ui/core/styles";
import ChipPickerSort from "../ChipPickerSort";
import { Trans, withTranslation } from "react-i18next";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Typography from "@material-ui/core/Typography";
import axios from "../../AxiosClient";
import PubSub from "pubsub-js";
import { PORTLET_LAYOUT_UPDATE } from "../../utils/Topics";

const styles = (theme) => ({
  section: {
    marginBottom: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  icon: {
    color: "rgba(0, 0, 0, 0.54)",
  },
});

export class SettingsDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 1,
      anchorEl: null,
      extendedSetting: [],
      listSetting: "",
      fullSetting: [],
      settingsOptions: [],
      settings: [],
      excludedFull: [],
      includedFull: [],
      excludedExtended: [],
      includedExtended: [],
    };
    this.saveSettings = this.saveSettings.bind(this);
  }

  componentDidMount() {
    this.setState({
      extendedSetting: this.props.portlet.settingsExtended
        ? JSON.parse(this.props.portlet.settingsExtended)
        : this.getDefaultExtendedSetting(false),
      fullSetting: this.props.portlet.settingsFullscreen
        ? JSON.parse(this.props.portlet.settingsFullscreen)
        : this.getDefaultExtendedSetting(false),
      listSetting: this.props.portlet.settingsList
        ? this.props.portlet.settingsList
        : this.getDefaultListSetting(false),
      settingsOptions: this.getDefaultExtendedSetting(true),
    });
  }

  getDefaultExtendedSetting(justText) {
    let settings;
    let extS = [];
    switch (this.props.portlet.objectClass) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.ReportInterface":
      case "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface":
        settings = this.props.documentOptions;
        break;
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        settings = this.props.discussionOptions;
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        settings = this.props.discussionEntryOptions;
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
      case "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface":
        settings = this.props.searchHistoryOptions;
        break;
      case "com.kpsol.api.apicommon.rework.ReworkInterface":
        settings = this.props.reworkOptions;
        break;
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        settings = this.props.requiredReadingOptions;
        break;
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        settings = this.props.knowledgeItemOptions;
        break;
      case "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface":
        settings = this.props.expertQuestionOptions;
        break;
      // case 'com.kpsol.api.apicommon.history.SearchHistoryInterface':
      //   settings = this.props.ContentRevisionOptions;
      //   break;
      default:
        settings = [];
    }
    if (justText) {
      return settings;
    } else {
      for (var i = 0; i < settings.length; i++) {
        extS.push({ label: settings[i], order: i });
      }
      return extS;
    }
  }

  getDefaultListSetting = () => {
    switch (this.props.portlet.objectClass) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.ReportInterface":
      case "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface":
        return "settings_document_author";
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        return "settings_discussions_date_last_post";
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        return "settings_discusssionsentry_edittime";
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
      case "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface":
        return "settings_document_created_date";
      case "com.kpsol.api.apicommon.rework.ReworkInterface":
        return "settings_date_created";
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        return "required_reading_date_created";
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        return "settings_knowledge_item_created_date";
      case "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface":
        return "settings_discussions_posted_by";
      default:
        return "";
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.listSetting !== this.state.listSetting) {
      for (let i = 0; i < this.state.settingsOptions.length; i++) {
        if (this.state.settingsOptions[i] === this.state.listSetting) {
          this.setState({ selectedIndex: i });
        }
      }
    }

    if (prevState.fullSetting !== this.state.fullSetting) {
      let full = this.state.includedFull.slice(0);
      let fullEx = this.state.excludedFull.slice(0);
      if (!this.state.fullSetting) {
        fullEx = [...this.state.excludedFull, ...this.state.settingsOptions];
      } else {
        full = this.state.fullSetting.map((el) => el.label);
        fullEx = this.state.settingsOptions.filter((el) => {
          return full.indexOf(el) < 0 ? true : false;
        });
      }
      this.setState({ excludedFull: fullEx, includedFull: full });
    }

    if (prevState.extendedSetting !== this.state.extendedSetting) {
      let ext = this.state.includedExtended.slice(0);
      let extEx = this.state.excludedExtended.slice(0);
      if (!this.state.extendedSetting) {
        extEx = [...this.state.excludedExtended, ...this.state.settingsOptions];
      } else {
        ext = this.state.extendedSetting.map((el) => el.label);
        extEx = this.state.settingsOptions.filter((el) => {
          return ext.indexOf(el) < 0 ? true : false;
        });
      }
      this.setState({ excludedExtended: extEx, includedExtended: ext });
    }
  }

  handleSelectChange = (e) => {
    this.setState({ listSetting: e.target.value });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { classes } = this.props;
    let options = [];
    switch (this.props.portlet.objectClass) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.ReportInterface":
      case "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface":
        options = this.props.documentOptions;
        break;
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        options = this.props.discussionOptions;
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        options = this.props.discussionEntryOptions;
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
        options = this.props.searchHistoryOptions.filter((o) => {
          return (
            o !== "settings_searchhistory_numberOfResults" &&
            o !== "settings_searchhistory_userCount"
          );
        });
        break;
      case "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface":
        options = this.props.searchHistoryOptions;
        break;
      case "com.kpsol.api.apicommon.list.ListUserListsInterface":
        options = this.props.listUserListOptions;
        break;
      case "com.kpsol.api.apicommon.rework.ReworkInterface":
        options = this.props.reworkOptions;
        break;
      case "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface":
        options = this.props.requiredReadingOptions;
        break;
      case "com.kpsol.api.apicommon.content.KnowledgeItemInterface":
        options = this.props.knowledgeItemOptions;
        break;
      case "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface":
        options = this.props.expertQuestionOptions;
        break;
      default:
        options = this.state.settingsOptions;
        break;
    }

    return (
      <>
        <DialogTitle id="api-dialog-title">
          <Trans i18nKey="edit_portlet_settings_header" />
        </DialogTitle>
        <DialogContent>
          <div className={classes.section}>
            <div
              className={classes.title}
              style={{
                flexGrow: 1,
                display: "flex",
                flex: 1,
                flexDirection: "row",
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <FormLabel component="legend">
                  <Trans i18nKey="edit_portlet_settings_label" />
                </FormLabel>
              </div>
            </div>
            <div
              className={classes.title}
              style={{
                flexGrow: 1,
                display: "flex",
                flex: 1,
                flexDirection: "row",
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Typography>
                  <Trans i18nKey="edit_portlet_list_settings" />
                </Typography>
                <FormHelperText>
                  <Trans i18nKey="edit_portlet_list_settings_helper_text" />
                </FormHelperText>
              </div>
            </div>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="list-settings">
                <Trans i18nKey="edit_portlet_list_settings" />
              </InputLabel>
              <Select
                aria-label="listSettings"
                style={{ minWidth: 200 }}
                value={this.state.listSetting}
                onChange={this.handleSelectChange}
                inputProps={{
                  name: "listSettings",
                  id: "list-settings",
                }}
              >
                {options.map((option) => (
                  <MenuItem
                    key={this.props.t(option)}
                    value={option}
                    aria-label={option}
                  >
                    {this.props.t(option)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Dialog>
              <div>
                <Trans i18nKey="portlet_attachment_edit_text" />
              </div>
            </Dialog>
          </div>
          <div className={classes.section}>
            <div
              className={classes.title}
              style={{
                flexGrow: 1,
                display: "flex",
                flex: 1,
                flexDirection: "row",
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Typography>
                  <Trans i18nKey="edit_portlet_fullscreen_settings" />
                </Typography>
                <FormHelperText>
                  <Trans i18nKey="edit_portlet_fullscreen_settings_helper_text" />
                </FormHelperText>
              </div>
            </div>
            <ChipPickerSort
              extended={false}
              excludedToIncluded={this.excludedToIncluded}
              includedToExcluded={this.includedToExcluded}
              included={this.state.includedFull}
              excluded={this.state.excludedFull}
              reorderIncluded={this.reorderFullIncluded}
            />
          </div>
          <div className={classes.section}>
            <div
              className={classes.title}
              style={{
                flexGrow: 1,
                display: "flex",
                flex: 1,
                flexDirection: "row",
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Typography>
                  <Trans i18nKey="edit_portlet_extended_settings" />
                </Typography>
                <FormHelperText>
                  <Trans i18nKey="edit_portlet_extended_settings_helper_text" />
                </FormHelperText>
              </div>
            </div>
            <ChipPickerSort
              extended={true}
              excludedToIncluded={this.excludedToIncluded}
              includedToExcluded={this.includedToExcluded}
              included={this.state.includedExtended}
              excluded={this.state.excludedExtended}
              reorderIncluded={this.reorderExtendedIncluded}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <div>
            <div />
            <Button onClick={this.props.close}>
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button onClick={this.saveSettings}>
              <Trans i18nKey="global_save" />
            </Button>
          </div>
        </DialogActions>
      </>
    );
  }
  reorderFullIncluded = (include) => {
    this.setState({ includedFull: include });
  };
  reorderExtendedIncluded = (include) => {
    this.setState({ includedExtended: include });
  };
  excludedToIncluded = (item, isExtended) => {
    let exclude = [];
    if (isExtended) {
      exclude = this.state.excludedExtended.slice(0);
    } else {
      exclude = this.state.excludedFull.slice(0);
    }
    exclude.map((excludeItem, idx) => {
      if (excludeItem === item) {
        exclude.splice(idx, 1);
      }
    });
    if (isExtended) {
      this.setState({ excludedExtended: exclude });
      let include = this.state.includedExtended.slice(0);
      include.push(item);
      this.setState({ includedExtended: include });
    } else {
      this.setState({ excludedFull: exclude });
      let include = this.state.includedFull.slice(0);
      include.push(item);
      this.setState({ includedFull: include });
    }
  };

  includedToExcluded = (item, isExtended) => {
    let include = [];
    if (isExtended) {
      include = this.state.includedExtended.slice(0);
    } else {
      include = this.state.includedFull.slice(0);
    }
    include.map((includeItem, idx) => {
      if (includeItem === item) {
        include.splice(idx, 1);
      }
    });
    if (isExtended) {
      this.setState({ includedExtended: include });
      let exclude = this.state.excludedExtended.slice(0);
      exclude.push(item);
      this.setState({ excludedExtended: exclude });
    } else {
      this.setState({ includedFull: include });
      let exclude = this.state.excludedFull.slice(0);
      exclude.push(item);
      this.setState({ excludedFull: exclude });
    }
  };
  saveSettings() {
    axios
      .patch(
        `/portalLayout/${this.props.portlet.portalLayoutID}/portlet/${
          this.props.portlet.id
        }`,
        {
          ...this.props.portlet,
          settingsExtended: JSON.stringify(this.getExtendedValues()),
          settingsFullscreen: JSON.stringify(this.getFullscreenValues()),
          settingsList: this.state.listSetting,
        }
      )
      .then((res) => {
        PubSub.publish(PORTLET_LAYOUT_UPDATE, { portlet: res.data });
        this.props.close();
      });
  }
  getExtendedValues = () => {
    let tempList = [];
    for (let i = 0; i < this.state.includedExtended.length; i++) {
      let newProp = {};
      newProp.label = this.state.includedExtended[i];
      newProp.order = i;
      tempList.push(newProp);
    }
    return tempList;
  };
  getFullscreenValues = () => {
    let tempList = [];
    for (let i = 0; i < this.state.includedFull.length; i++) {
      let newProp = {};
      newProp.label = this.state.includedFull[i];
      newProp.order = i;
      tempList.push(newProp);
    }
    return tempList;
  };
}
const mapStateToProps = (state) => ({
  documentOptions: state.selectionOption.documentSettingsOptions,
  discussionOptions: state.selectionOption.discussionSettingsOptions,
  discussionEntryOptions: state.selectionOption.discussionEntrySettingsOptions,
  searchOptions: state.selectionOption.searchSettingsOptions,
  listUserListOptions: state.selectionOption.listUserListSettingsOptions,
  templateOptions: state.selectionOption.templateSettingsOptions,
  reworkOptions: state.selectionOption.reworkSettingsOptions,
  requiredReadingOptions: state.selectionOption.requiredReadingSettingsOptions,
  knowledgeItemOptions: state.selectionOption.knowledgeItemSettingsOptions,
  expertQuestionTemplateOptions:
    state.selectionOption.expertQuestionTemplateSettingsOptions,
  expertQuestionOptions: state.selectionOption.expertQuestionSettingsOptions,
  ContentRevisionOptions: state.selectionOption.contentRevisionSettingsOptions,
  user: state.user.currentUser,
  searchHistoryOptions: state.selectionOption.searchHistorySettingsOptions,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withRouter(withTranslation()(SettingsDocuments))));
